import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { EmployeeTimeOff } from '../../../types/EmployeeTimeOff';
import CustomAxios from '../../../utility/customAxios';
import { mutationKeys } from '../mutationKeys';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const postEmployeeTimeOff = async (formData: EmployeeTimeOff) => {
  const response = await CustomAxios.post('employee_time_offs', formData);
  return response.data;
};

type UseCreateEmployeeTimeOffProps = {
  onSuccessCallback: (data: EmployeeTimeOff) => void;
};

export function useCreateEmployeeTimeOff({ onSuccessCallback }: UseCreateEmployeeTimeOffProps) {
  return useMutation({
    mutationKey: [mutationKeys.createEmployeeTimeOff],
    mutationFn: (formData: EmployeeTimeOff) => postEmployeeTimeOff(formData),
    onSuccess: (data: EmployeeTimeOff) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allEmployeeTimeOffs],
      });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.employeeTimeOffAvailability],
      });
      onSuccessCallback(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const employeeTimeOff = err.response.data as EmployeeTimeOff;

        queryClient.setQueryData([queryKeys.allEmployeeTimeOffs, 'new'], employeeTimeOff);
      }
    },
  });
}
